export enum RefreshType {
  RECOMMENDED = 'recommended',
  REQUIRED = 'required',
  FORCE = 'force',
}
